module.exports = __webpack_public_path__ + "media/images/common/2column_product_bg_nyy-b514fbeb652fb7f038118227c8ca7b6c.png";